<template>
  <Tooltip>
    <template #element>
      <span>
        Pause vor Wiederholung
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Bewertung, wie lange eine Methode mindestens pausiert werden sollte, um bei Wiederanwendung die größtmöglichen Effekte zu erzielen
      </span>
    </template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
